import CONSTANTS from '../constants';
import { alerts } from './alerts';
import MemberService from '../services/memberService';
import CacheService from '../services/cacheService';

export function checkEmail(bname, email) {
    return dispatch => {
        // Check email returns success if email exists, its needed for mobile APIs
        return MemberService.checkEmail(bname, email).then((response) => {
            if(response.data.success) dispatch(alerts.error('Email already exists'));
            return response;
        }).catch(() => {
            dispatch(alerts.error('Invalid email or business name'));
        });
    };
}


export function signUp(params, history) {
    return dispatch => {
        MemberService.signUp(params).then((response) => {
            if(response.data.success) {
                dispatch(alerts.success('Account created successfully.'));
                history.push(`/${params.bname}/login`);
            } else {
                dispatch(alerts.error(response.data.message));
                history.push(`/${params.bname}/login`);
            }
        }).catch((error) => {
            dispatch(alerts.error(error));
        });
    };
}

export function login(bname, email, password, history) {
	return dispatch => {
		MemberService.login(bname, email, password).then((response) => {
			let {access_token} = response.data;
			CacheService.setToken(access_token, bname);
			dispatch(success(access_token, bname));
			if(history.location.state) {
                history.push(history.location.state.from.pathname);
            } else {
			    history.push(`/${CacheService.getToken().bname}/`);
            }
		}).catch((error) => {
			dispatch(failure(error));
			dispatch(alerts.error('Invalid username or password'));
		});
	};
	
	function success(token, bname) { return { type: CONSTANTS.ACTIONS.LOGIN.SUCCESS, token: token, bname: bname } }
	function failure(error) { return { type: CONSTANTS.ACTIONS.LOGIN.FAILURE, error } }
}

export function forgotPassword(bname, email, history) {
    return dispatch => {
        MemberService.forgotPassword(bname, email).then((response) => {
            if(response.data.success) {
                history.push(`/${bname}/reset_password?email=${email}`);
                dispatch(alerts.success('Password reset instructions have been sent to your email'));
            } else {
                dispatch(alerts.error(response.data.message));
            }
        }).catch(() => {
            dispatch(alerts.error('Invalid email or business name'));
        });
    };
}

export function resetPassword(bname, email, resetPasswordToken, newPassword, passwordConfirmation, history) {
    return dispatch => {
        MemberService.resetPassword(bname, email, resetPasswordToken, newPassword, passwordConfirmation).then((response) => {
            if(response.data.success) {
                history.push(`/${bname}/login`);
                dispatch(alerts.success('Your password has been reset'));
            } else {
                dispatch(alerts.error(response.data.message));
            }
        }).catch(() => {
            dispatch(alerts.error('Invalid email or business name'));
        });
    };
}

export function changePassword(oldPassword, newPassword, passwordConfirmation, history) {
    return dispatch => {
        MemberService.changePassword(oldPassword, newPassword, passwordConfirmation).then(() => {
            history.push(`/${CacheService.getToken().bname}/`);
            dispatch(alerts.success('Your password has been changed.'));
        }).catch(() => {
            dispatch(alerts.error('Invalid email or business name'));
        });
    };
}


// WEBPACK FOOTER //
// ./src/actions/sessions.js